var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfCustom = function SvgPdfCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.39 14.833h-1.027V9.16h2.413v1.028H16.39v1.296h1.385v1.027H16.39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.227 14.833h1.027V12.51H8.55a1 1 0 0 0 .732-.295 1 1 0 0 0 .295-.732v-1.296a1 1 0 0 0-.295-.733 1 1 0 0 0-.732-.295H6.227zm1.027-4.646v1.296H8.55v-1.296zM10.761 14.833h2.279a1 1 0 0 0 .732-.294 1 1 0 0 0 .296-.733v-3.62a1 1 0 0 0-.296-.732 1 1 0 0 0-.732-.295H10.76zm1.028-4.646v3.619h1.25v-3.62z",
    clipRule: "evenodd"
  })));
};
export default SvgPdfCustom;